import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconChevronDownSmall = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M9.54 10.969a.782.782 0 0 0-.54-.211.782.782 0 0 0-.54.21.73.73 0 0 0-.21.54c0 .203.07.375.21.515l3 3a.741.741 0 0 0 .54.235.741.741 0 0 0 .54-.235l3-3c.14-.14.21-.312.21-.515a.73.73 0 0 0-.21-.54.782.782 0 0 0-.54-.21.782.782 0 0 0-.54.21L12 13.43l-2.46-2.461z" }),
});

export { IconChevronDownSmall };
